import Vue from 'vue';
import VueRouter from 'vue-router';
// 修复路由报错Navigation aborted from “/a“ to “/b“ via a navigation guard，
// 参考：https://blog.csdn.net/weixin_43840202/article/details/108086354
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

export const constantRoutes = [
  {
    path: '/login',
    name: 'LoginIndex',
    component: () => import('../views/login'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/login-auth',
    name: 'LoginAuth',
    component: () => import('../views/login/auth.vue'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/callback',
    name: 'PageCallback',
    component: () => import('@/views/callback'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/404',
    name: 'ErrorPage404',
    component: () => import('../views/error/404'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/403',
    name: 'ErrorPage403',
    component: () => import('../views/error/403'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/rP/reset',
    name: 'rP',
    component: () => import('@/views/resetPwd'),
    meta: {
      hidden: true,
    },
  },
];

export const blankRoutes = [
  {
    path: '/process/design/engine/:id/:formType/:userType/:type/:stepNum', // id 流程id   type 0新增 1详情 2编辑  stepNum新增 -1 编辑 2
    name: 'ProcessEngine',
    component: () => import('@/views/process/engine'),
    meta: {
      title: '流程引擎',
      hidden: true,
      guard: {
        role: ['Admin'],
        permission: [],
      },
    },
  },
  {
    path: '/process/initiate/form-detail/:flowId/:id/:taskId/:taskNodeId',
    name: 'MatterDetail',
    component: () => import('@/views/process/detail'),
    meta: {
      title: '流程引擎 - 流程事宜',
      hidden: true,
      /* guard: {
         permission: [],
       },*/
    },
  },
];

const router = createRouter();

function fatteningRoutes(routes) {
  return routes.flatMap((route) => {
    return route.children ? fatteningRoutes(route.children) : route;
  });
}

export function resetRouter(routes = constantRoutes) {
  routes.map((route) => {
    if (route.children) {
      route.children = fatteningRoutes(route.children);
    }
  });
  router.matcher = createRouter(routes).matcher;
}

function createRouter(routes = constantRoutes) {
  return new VueRouter({
    mode: 'hash',
    // hash模式时在不确定二级目录名称的情况下建议使用""代表相对路径或者"/二级目录/"
    // history模式默认使用"/"或者"/二级目录/"
    base: '',
    routes,
  });
}

export default router;
